import { createSvgIcon } from '@mui/material/utils'

export const FolderIcon = createSvgIcon(
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2.00077 7.01439L2.0007 14.9513C2.00069 15.8718 2.74688 16.618 3.66736 16.618L16.333 16.618C17.2534 16.618 17.9996 15.8719 17.9996 14.9514L17.9999 6.67753C17.9999 6.21729 17.6268 5.84418 17.1666 5.84418H10.0697L7.76547 3.38281H2.83356C2.3732 3.38281 2.00005 3.75549 2.0002 4.21585C2.00045 5.00819 2.00078 6.19729 2.00077 7.01439Z' stroke-width='1.66667' stroke-linecap='round' stroke-linejoin='round' />
  </svg>

)
